import AuthService from '@/services/AuthService';

export const exam = {
  namespaced: true,
  state: {
    home_work: null,
    old_home_work: null,
  },
  actions: {
    homeWork({ commit }, data) {
      return AuthService.home_work(data).then(
        home_work => {
          commit('homeWorkSuccess', { data: home_work, status: data.status });
          return Promise.resolve(home_work);
        },
        error => {
          commit('homeWorkFailure', error);
          return Promise.reject(error);
        },
      );
    },
  },
  mutations: {
    homeWorkSuccess(state, home_work) {
      if (home_work.status == 'aktif') {
        state.home_work = home_work.data
      } else  {
        state.old_home_work = home_work.data
      }
    },
    homeWorkFailure(state) {
      state.home_work = {};
    }
  }
};